import moment from 'moment';
import { i18n, TFunction } from "i18next";
import { useTranslation } from 'react-i18next';
import { formatBytes } from 'util/formatBytes';

export const oneDay = 86400000;
export const threeDays = oneDay * 3;
export const oneMinute = 60000;
const quarterHour = 900000;
const oneHour = 3600000;


//
// Show the hours within a day (e.g. "6pm") but show the day name
// (e.g. "Jul 10") at the start of the day instead of "12am"
//
export const formatTimeTickLabel = (timeZone: string, i18n: i18n) => (tick: number) => {
    const time = moment.tz(tick, timeZone).locale(i18n.language);
    const startOfDay = time.clone().startOf('day');
    if (time.isSame(startOfDay)) {
        return time.format('MMM Do');
    }
    return time.format('ha');
};

export const formatHourMinuteLabel = (timeZone: string, i18n: i18n) => (tick: number) => {
    const time = moment.tz(tick, timeZone).locale(i18n.language);
    return time.format('h:mm A');
};

//
// Generate a label with the number of kilobytes,
// with digit groupings.
//
export const formatSizeTickLabel = (t: TFunction) => function (tick: number, index: number) {
    return formatBytes(t, tick);
};


const chartStyles: React.CSSProperties = { opacity: .125, lineHeight: '200px', textAlign: 'center', fontSize: '2em' };

export const NoData = () => {
    const { t } = useTranslation();
    return (
        <div style={ chartStyles }>
            { t('DEVICE.STATUS.NO_DATA') }
        </div>
    );
};

export const LoadingChart = () => {
    const { t } = useTranslation();
    return (
        <div style={ chartStyles }>
            { t('LOADING') }
        </div>
    );
};


export function calculateNextQuarterHour(timestamp: number) {
    return timestamp + quarterHour - (timestamp % quarterHour);
}

export function calculateThisSixHours(timestamp: number) {
    return timestamp - (timestamp % (6 * oneHour));
}

export function generateTicks(thisSixHours: number): number[] {
    const ticks: number[] = [];
    for (let i = 11; i >= 0; i--) {
        ticks.push(thisSixHours - i * (oneHour * 6));
    }
    return ticks;
}
